import { useMemo } from "react";
import { PrintData } from "../../../../../../print-configuration/PrintConfigration";
import { useUser } from "src/shared/context/UserContext";
import { Order } from "src/shared/services/interfacev2";
import { splitDateTime } from "src/shared/components/dateTime";
import { CustomerData } from "src/shared/services/interface";
import { useUserHelpers } from "src/shared/utils/userHelpers";
import { date } from "../../../orders/order-display/orderHelpers";

export function usePrintData(
  order: Order,
  outstandingBalance: number | string,
  clientId: string,
  arabicName: string,
  businessLocation: string,
  customer: CustomerData | any,
  editedAmounts: { [productId: string]: string } = {},
): PrintData {
  const { user } = useUser();
  const { getUserNameById } = useUserHelpers();
  const creatorName = getUserNameById(order?.orderDetails?.[0]?.createdBy) || order?.orderDetails?.[0]?.createdBy || "Unknown";
  return useMemo(() => {
    const paid = order?.paymentHistory?.map((p) => Number(p.receivedAmount)).reduce((acc, curr) => acc + curr, 0) || 0;

    const products =
      order?.orderDetails?.[0]?.products?.map((p) => {
        const unitPrice = Number(editedAmounts[p.productId] ?? p.unitPrice);

        return {
          productName: p.name ?? "",
          arabicword: p.arabicName,
          amount: unitPrice,
          quantity: Number(p.quantity ?? 0),
          totalPrice: unitPrice * Number(p.quantity ?? 0),
        };
      }) || [];
    const { date: orderDate, time: orderTime } = splitDateTime(order?.orderDetails[0].orderedOn.$date ?? "");
    const CustomerName = [order?.customerDetails?.firstName, order?.customerDetails?.middleName, order?.customerDetails?.lastName].filter(Boolean).join(" ");

    return {
      CustomerName: CustomerName,
      CustomerPhon: order?.customerDetails.phones?.[0]?.phone || "",
      OrderId: order?.orders?.[0]?.orderId || "",
      OrderStatus: order?.orders?.[0]?.status || "",
      Date: orderDate,
      Time: orderTime,
      Products: products,
      Paid: paid,
      unpaid: Math.max(0, Number(order?.orders?.[0]?.remainingAmount || 0)),
      OSB: Number(outstandingBalance || 0),
      busnessName: user?.orgName || "",
      busnessArabicName: user?.orgArabicName || "",
      businessLocation: businessLocation,
      phoneNum: user?.phones || "",
      total: Number(order?.orders?.[0]?.orderAmount || 0),
      clientId: clientId,
      discount: Number(order?.orders?.[0]?.discount || 0),
      subtotal: Number(order?.orders?.[0]?.finalAmount || 0),
      deliveryFee: Number(order?.orders?.[0]?.deliveryFee || 0),
      billNo: order?.orders?.[0]?.billNumber,
      paymentMethod: order?.paymentHistory?.length > 1 ? " Split" : order?.paymentHistory?.map((p) => p.paymentMethod).join(", ") || "",
      createdBy: order?.orders?.[0]?.createdByName || "Unknown",
      payMentHistoryAvabile: order?.paymentHistory?.length > 1,
      // payMentHistory: order?.paymentHistory?.map((p) => ({
      //   Paymentmethod: p.paymentMethod || "",
      //   ReceivedAmount: Number(p.receivedAmount),
      //   date: orderDate,
      //   payment_on: orderDate,
      //   balance: Number(order?.orders?.[0]?.remainingAmount || 0),
      //   paidAmount: Number(p.receivedAmount),
      // })),
      payMentHistory: (() => {
        const totalAmount = Number(order?.orders?.[0]?.finalAmount || 0);

        let balance = totalAmount;

        return (order?.paymentHistory || []).map((p) => {
          const receivedAmount = Number(p.receivedAmount || 0);

          balance = Math.max(0, balance - receivedAmount);

          return {
            Paymentmethod: p.paymentMethod || "",
            ReceivedAmount: receivedAmount,
            date: orderDate,
            payment_on: orderDate,
            balance,
            paidAmount: receivedAmount,
          };
        });
      })(),
    };
  }, [order, outstandingBalance, clientId, arabicName, businessLocation, user]);
}
